import { parsePaymentLineAmount } from "features/leads/components/addSalesModal/components/addSalesForm/components/paymentSection/utils/paymentUtils"

export const FRACTIONAL_PAYMENT_CHANNEL_STANDARD = "standard"
export const FRACTIONAL_PAYMENT_CHANNEL_PSID = "payment_slip_id"

export function isFractionalPsidChannelRowComplete(row, psidPaymentModeKey) {
  if (!row || psidPaymentModeKey == null) return false
  const amt = parsePaymentLineAmount(row.amount)
  if (!(amt > 0)) return false
  const mode =
    typeof row.modeOfPayment === "object" ? (row.modeOfPayment?.key ?? row.modeOfPayment?.value) : row.modeOfPayment
  if (mode !== psidPaymentModeKey) return false
  if (row.enableDepositRA === true) {
    return !!row.regional_accountant
  }
  return true
}

export function paymentModesMapFromResponse(response) {
  return (
    response?.reduce((acc, parent) => {
      acc[parent?.key] = {
        meta: { ...parent },
        extraFields: parent?.PaymentModeAttachmentTypeMappings?.reduce((childAcc, child) => {
          childAcc[child?.AttachmentType?.key] = {
            id: child?.id,
            attachmentTypeId: child?.AttachmentType?.id,
            key: child?.AttachmentType?.key,
            name: child?.AttachmentType?.name,
            required: child?.required,
          }
          return childAcc
        }, {}),
      }
      return acc
    }, {}) ?? {}
  )
}

export function resolvePsidPaymentModeKey(modeOfPayments) {
  const found = (modeOfPayments || [])?.find(m => `${m?.name || ""} ${m?.key || ""}`.includes("payment_slip_id"))
  return found?.key ?? null
}

export function modeMetaIsPsid(modeMeta, modeKey, psidPaymentModeKey) {
  if (!modeMeta && modeKey == null) return false
  if (psidPaymentModeKey != null && modeKey === psidPaymentModeKey) return true
  const label = `${modeMeta?.name || ""} ${modeMeta?.key || ""}`
  return label.includes("payment_slip_id")
}

export function isPsidModeKey(modeKey, modeOfPayments) {
  if (modeKey == null || modeKey === "") return false
  const resolved = resolvePsidPaymentModeKey(modeOfPayments)
  if (resolved != null && modeKey === resolved) return true
  const meta = modeOfPayments?.find(m => m.key === modeKey)
  return meta ? modeMetaIsPsid(meta, modeKey, resolved) : false
}
